import { render, staticRenderFns } from "./ReworksMarksRootView.vue?vue&type=template&id=1ce65220"
import script from "./ReworksMarksRootView.vue?vue&type=script&lang=js"
export * from "./ReworksMarksRootView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports